import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from '../useMutationApi';
import { RebateAgreementDTO } from './types';

interface CloseAgreementRequest {
  reason: 'immaterial' | 'settled' | 'fully_paid' | 'dispute' | 'other';
  notes?: string;
}

interface CloseAgreementResponse {
  success: boolean;
  message: string;
  data: {
    id: string;
    isClosedOut: boolean;
    closureMetadata: RebateAgreementDTO['closureMetadata'];
  };
}

/**
 * Hook to close a finalized, expired rebate agreement
 */
const useCloseRebateAgreement = (agreementId: string) => {
  const queryClient = useQueryClient();

  return useMutationApi<CloseAgreementRequest, CloseAgreementResponse>({
    endpoint: `rebates/agreements/${agreementId}/close`,
    method: 'POST',
    options: {
      onSuccess: () => {
        // Invalidate rebate agreements queries to refresh the data
        queryClient.invalidateQueries({
          queryKey: ['rebates/agreements'],
        });
        queryClient.invalidateQueries({
          queryKey: [`rebates/agreements/${agreementId}`],
        });
      },
    },
    successMessage: 'Agreement closed successfully',
  });
};

export default useCloseRebateAgreement;
